module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (!_vm.multiple) ? _c('select', {
    staticStyle: {
      "width": "100%"
    }
  }, [_vm._t("default")], 2) : _c('select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "multiple": ""
    }
  }, [_vm._t("default")], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1d9c2304","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Input/Select2.vue
// module id = 836
// module chunks = 1